import React, { Component } from 'react';
import {Bar} from 'react-chartjs-2';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Checkbox from '@material-ui/core/Checkbox';
import GetNuevaOrden from './getNuevaOrden';
class getReportes extends Component {
  constructor(){
    super();
    this.state = {
      id_tipo_reporte:0,
      id_anio:2025,
      fecha_inicio:'',
      fecha_fin:'',
      data:[],
      date_desde : new Date(),
      date_hasta : new Date(),
      tipo_busqueda:0,
      id_tipo_subreporte:0
    }
  }
  onChangeDesde = date => this.setState({ date_desde:date,
  tipo_busqueda:0 },()=>{
    this.setReporte()
  })

  onChangeHasta = date => this.setState({ date_hasta:date,
  tipo_busqueda:0 },()=>{
    this.setReporte()
  })

  handleCalendarClose = () => {
    console.log("Calendar closed");
  }

  handleCalendarOpen = () => {
      console.log("Calendar opened");
  }
  handleChangeE = (event)=>{
    this.setState({
       id_anio: event.target.value,
       data:[],
       tipo_busqueda:0
    },()=>{
      this.setReporte()
    });
  }
  handleChanget = (event)=>{
    this.setState({
       id_tipo_reporte: event.target.value,
       data:[],
       tipo_busqueda:0
    },()=>{
      this.setReporte()
    });
  }
  handleChanget_1= (event)=>{
    this.setState({
       id_tipo_subreporte: event.target.value,
       data:[],
       tipo_busqueda:0
    },()=>{
      this.setReporte()
    });
  }
  formatDate=(date)=> {
     var d = new Date(date),
         month = '' + (d.getMonth() + 1),
         day = '' + d.getDate(),
         year = d.getFullYear();

     if (month.length < 2)
         month = '0' + month;
     if (day.length < 2)
         day = '0' + day;

     return [year, month, day].join('-');
  }

  setReporteExportar =(valor)=>{
    if(Number(valor)===0){
      const fecha_inicio = this.formatDate(this.state.date_desde)
      const fecha_fin = this.formatDate(this.state.date_hasta)
      const id_tipo_permiso= Number(this.props.id_tipo_permiso)
      let id_sucursal= Number(this.props.id_sucursal)
      if(Number(id_tipo_permiso)!==5){
        id_sucursal=0
      }
      const url= this.props.dir_url + "webapp/export/1/"+fecha_inicio+"/"+fecha_fin+"/"+id_tipo_permiso+"/"+id_sucursal;
      window.open(url, "_self")
    }else{
      const fecha_inicio = this.formatDate(this.state.date_desde)
      const fecha_fin = this.formatDate(this.state.date_hasta)
      const id_tipo_permiso= Number(this.props.id_tipo_permiso)
      let id_sucursal= Number(this.props.id_sucursal)
      if(Number(id_tipo_permiso)!==5){
        id_sucursal=0
      }
      const url= this.props.dir_url + "webapp/export/2/"+fecha_inicio+"/"+fecha_fin+"/"+id_tipo_permiso+"/"+id_sucursal;
      window.open(url, "_self")
    }
  }

  getvalidar =()=>{
    let tipo_busqueda = this.state.tipo_busqueda
    if(Number(tipo_busqueda)===0){
      tipo_busqueda=1;
    }else{
      tipo_busqueda=0;
    }
    this.setState({
      tipo_busqueda
    })
  }
  setReporte =()=>{
    const id_tipo_reporte =  Number(this.state.id_tipo_reporte)
    const id_tipo_subreporte =  Number(this.state.id_tipo_subreporte)
    const id_tipo_permiso= Number(this.props.id_tipo_permiso)
    const id_sucursal = Number(this.props.id_sucursal)
    const id_anio = Number(this.state.id_anio)
    if(id_tipo_reporte===0)return
    if(id_anio===0)return

    const fecha_inicio = this.formatDate(this.state.date_desde)
    const fecha_fin = this.formatDate(this.state.date_hasta)

    //const fecha_inicio = this.state.fecha_inicio
    //const fecha_fin = this.state.fecha_fin
    const url= this.props.dir_url + "webapp/getReporte";
    const token =  this.props.token
    var obj = { accion:'getreporte', token,id_tipo_reporte,id_anio,fecha_inicio,fecha_fin,id_tipo_subreporte,id_tipo_permiso,id_sucursal};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      //console.log(data[0].msg)
      if(data[0].status==="ok"){
        if(id_tipo_reporte===5){
          this.setState({
            data:data
          })
        }else{
          this.setState({
            data:data[0].msg
          })
        }

      }else{
        this.setState({
          data:[]
        })
      }
    })
    .catch(console.log)
  }
  render(){
   let modulo
   const  id_tipo_reporte = Number(this.state.id_tipo_reporte)
   if(id_tipo_reporte===1){
     modulo =  <div className="cssversion_pw100 cssversion_ph100">
                  <React.Fragment> Año:<br/>
                  <select className="select-css_global" value={this.state.id_anio} onChange={(e) => {this.handleChangeE(e)}}>
                    <option value="2025">2025</option>
                    <option value="2024">2024</option>
                    <option value="2023">2023</option>
                    <option value="2022">2022</option>
                    <option value="2021">2021</option>
                    <option value="2020">2020</option>
                    <option value="2019">2019</option>
                  </select>
                  </React.Fragment>
                  {this.state.data.map(subrubro => (
                      <div className="lbl_chart_2">
                      <h2>{subrubro.sucursal+""}</h2>
                      <h2>Ventas {subrubro.labelf+""}</h2>
                        <div className="lbl_chart_2_sub">
                          <Bar key={subrubro.id}
                            data={subrubro.grafico[0]}
                            width={100}
                            height={80}
                            options={{
                              maintainAspectRatio: false
                            }}
                          />
                        </div>
                      </div>
                  ) ) }
                </div>
   }
   if(id_tipo_reporte===2){
     modulo =  <div className="cssversion_pw100 cssversion_ph100">
                  <React.Fragment> Año:<br/>
                  <select className="select-css_global" value={this.state.id_anio} onChange={(e) => {this.handleChangeE(e)}}>
                    <option value="2025">2025</option>
                    <option value="2024">2024</option>
                    <option value="2023">2023</option>
                    <option value="2022">2022</option>
                    <option value="2021">2021</option>
                    <option value="2020">2020</option>
                    <option value="2019">2019</option>
                  </select>
                  </React.Fragment>
                  {this.state.data.map(subrubro => (
                      <div className="lbl_chart_2">
                      <h2>{subrubro.sucursal+""}</h2>
                      <h2>Domicilios {subrubro.labelf+""}</h2>
                        <div className="lbl_chart_2_sub">
                          <Bar key={subrubro.id}
                            data={subrubro.grafico[0]}
                            width={100}
                            height={80}
                            options={{
                              maintainAspectRatio: false
                            }}
                          />
                        </div>
                      </div>
                  ) ) }
                </div>
   }

   //uuid_imagen, cantidad, producto, precio_neto

   if(id_tipo_reporte===3){
     const url_image = this.props.url_image// "https://firebasestorage.googleapis.com/v0/b/"
     const separator = this.props.separator//"/o/images%2F"
     const file_xxx =this.props.file_60x60
     //const file_xxx250x200 =this.props.file_250x200
     const token_image = url_image+file_xxx+separator
     //const token_image_rubro = url_image+file_xxx250x200+separator
     const ext="_60x60.png?alt=media"
     modulo =  <div className="cssversion_pw100 cssversion_ph100">
                  <div className="cssversion_pw100 cssversion_ph10" style={{"display":"flex"}}>
                    <div className="cssversion_pw50 cssversion_ph100 cssversion_contentCenter">
                      <label>Desde</label><DatePicker selected={this.state.date_desde} onChange={this.onChangeDesde} onCalendarClose={this.handleCalendarClose} onCalendarOpen={this.handleCalendarOpen} /><br/>
                      <label>Hasta</label><DatePicker selected={this.state.date_hasta} onChange={this.onChangeHasta} onCalendarClose={this.handleCalendarClose} onCalendarOpen={this.handleCalendarOpen} />
                    </div>
                    <div className="cssversion_pw50 cssversion_ph100 cssversion_contentCenter">
                      <button className="button-global" style={{"width":"250px"}} onClick={ () => this.setReporte()}>Buscar</button>
                    </div>
                  </div>
                  <div className="cssversion_pw100 cssversion_ph90">
                    <div className="cssversion_pw100 cssversion_pxh60" style={{"display":"flex"}}>
                      <div className="cssversion_pw25 cssversion_ph100 cssversion_contentCenter">
                        Imagen
                      </div>
                      <div className="cssversion_pw25 cssversion_ph100 cssversion_contentCenter">
                        Producto
                      </div>
                      <div className="cssversion_pw25 cssversion_ph100 cssversion_contentCenter">
                        Cantidad
                      </div>
                      <div className="cssversion_pw25 cssversion_ph100 cssversion_contentCenter">
                        Total Vendido
                      </div>
                    </div>
                    {this.state.data.map(subrubro => (
                      <React.Fragment>
                        <div className="cssversion_pw100 cssversion_pxh60" style={{"display":"flex"}}>
                          <div className="cssversion_pw25 cssversion_ph100 cssversion_contentCenter">
                            <img style={{"width":"60px","height":"60px","borderRadius": "20%"}} className="icon-global" alt="Cargando Imagen . . ."
                             src={
                               ((subrubro.uuid_imagen+'').trim()==='')?
                                 "https://www.grupomn.net/app/img/sinfoto.png"
                               :
                                 token_image+subrubro.uuid_imagen+ext
                               }/>
                          </div>
                          <div className="cssversion_pw25 cssversion_ph100 cssversion_contentCenter">
                            {subrubro.producto}
                          </div>
                          <div className="cssversion_pw25 cssversion_ph100 cssversion_contentCenter">
                            {subrubro.cantidad}
                          </div>
                          <div className="cssversion_pw25 cssversion_ph100 cssversion_contentCenter">
                            {subrubro.precio_neto}
                          </div>
                        </div>
                        </React.Fragment>
                      ))
                    }
                  </div>
                </div>
   }
 //codigo, nombre, total
   if(id_tipo_reporte===4){
     modulo =  <div className="cssversion_pw100 cssversion_ph100">
                  <div className="cssversion_pw100 cssversion_ph10" style={{"display":"flex"}}>
                    <div className="cssversion_pw50 cssversion_ph100 cssversion_contentCenter">
                      <label>Desde</label><DatePicker selected={this.state.date_desde} onChange={this.onChangeDesde} onCalendarClose={this.handleCalendarClose} onCalendarOpen={this.handleCalendarOpen} /><br/>
                      <label>Hasta</label><DatePicker selected={this.state.date_hasta} onChange={this.onChangeHasta} onCalendarClose={this.handleCalendarClose} onCalendarOpen={this.handleCalendarOpen} />
                    </div>
                    <div className="cssversion_pw50 cssversion_ph100 cssversion_contentCenter">
                      <button className="button-global" style={{"width":"250px"}} onClick={ () => this.setReporte()}>Buscar</button>
                    </div>
                  </div>
                  <div className="cssversion_pw100 cssversion_ph90">
                    <div className="cssversion_pw100 cssversion_pxh60" style={{"display":"flex"}}>
                      <div className="cssversion_pw25 cssversion_ph100 cssversion_contentCenter">
                        Número
                      </div>
                      <div className="cssversion_pw25 cssversion_ph100 cssversion_contentCenter">
                        Nombre
                      </div>
                      <div className="cssversion_pw25 cssversion_ph100 cssversion_contentCenter">
                        Total Pedidos
                      </div>
                    </div>
                    {this.state.data.map(subrubro => (
                      <React.Fragment>
                        <div className="cssversion_pw100 cssversion_pxh60" style={{"display":"flex"}}>
                          <div className="cssversion_pw30 cssversion_ph100 cssversion_contentCenter">
                            {subrubro.codigo}
                          </div>
                          <div className="cssversion_pw30 cssversion_ph100 cssversion_contentCenter">
                            {subrubro.nombre}
                          </div>
                          <div className="cssversion_pw30 cssversion_ph100 cssversion_contentCenter">
                            {subrubro.total}
                          </div>
                        </div>
                        </React.Fragment>
                      ))
                    }
                  </div>
                </div>
   }
   console.log(this.state.id_tipo_subreporte)
   if(id_tipo_reporte===5){
     const data_sucursal_transferencia = this.state.data_sucursal_transferencia
       const roundTo = require('round-to');
     modulo =  <div className="cssversion_pw100 cssversion_ph100">
                  <div className="cssversion_pw100 cssversion_ph10" style={{"display":"flex"}}>
                    <div className="cssversion_pw50 cssversion_ph100 cssversion_contentCenter">
                      <label>Desde</label><DatePicker selected={this.state.date_desde} onChange={this.onChangeDesde} onCalendarClose={this.handleCalendarClose} onCalendarOpen={this.handleCalendarOpen} /><br/>
                      <label>Hasta</label><DatePicker selected={this.state.date_hasta} onChange={this.onChangeHasta} onCalendarClose={this.handleCalendarClose} onCalendarOpen={this.handleCalendarOpen} />
                      Ver Detallado<Checkbox inputProps={{ 'aria-label': 'primary checkbox' }} checked={(Number(this.state.tipo_busqueda)===1)?true:false}
                        onClick={ () => this.getvalidar()}/>
                    </div>
                  </div>
                  <div className="cssversion_pw100 cssversion_ph10" style={{"display":"flex"}}>
                    <div className="cssversion_pw50 cssversion_ph100 cssversion_contentCenter">
                      <select className="select-css_global" value={this.state.id_tipo_subreporte} disabled={(Number(this.props.id_tipo_permiso)===5)?true:false} onChange={(e) => {this.handleChanget_1(e)}}>
                        <option value="0">Seleccione Sucursal</option>
                        {(data_sucursal_transferencia.length !== 0) ?
                          data_sucursal_transferencia[0].map((suc_tra,index) => (
                            <option key={index} value={Number(suc_tra.id_sucursales)} >{suc_tra.sucursales}</option>
                          ))
                          : <React.Fragment></React.Fragment>
                        }
                      </select>
                    </div>
                    <div className="cssversion_pw50 cssversion_ph100 cssversion_contentCenter">
                      <button className="button-global" style={{"width":"250px"}} onClick={ () => this.setReporteExportar(0)}>Buscar</button>
                    </div>
                  </div>
                  <div className="cssversion_pw100 cssversion_ph90">
                    <div className="cssversion_pw80 cssversion_ph80">
                      <table className="tb_pedidos">
                        <thead>
                        <tr>
                          <th>Motorizado</th>
                          <th>Total</th>
                          <th>Efectivo</th>
                          <th>Tarjeta</th>
                          <th>Delivery</th>
                          <th>Forma de Pago</th>
                          <th>Sucursales</th>
                          <th>Código</th>
                          <th>Cliente</th>
                          <th>Fecha Pedido</th>
                          <th>Cód Pedido</th>
                          <th>Kilometraje</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.data.map(usuario => (
                          <React.Fragment>
                          <tr style={{"backgroundColor":"#0B2F3A","color":"white"}}>
                              <td>
                                {usuario.Cusuario}
                              </td>
                              <td style={{"textAlign":"right"}}>
                                {roundTo(Number(usuario.total_efectivo)+Number(usuario.total_tarjeta),2)}
                              </td>
                              <td style={{"textAlign":"right"}}>
                                {usuario.total_efectivo}
                              </td>
                              <td style={{"textAlign":"right"}}>
                                {usuario.total_tarjeta}
                              </td>
                              <td style={{"textAlign":"right"}}>
                                {usuario.total_delivery}
                              </td>
                          </tr>
                          {(Number(this.state.tipo_busqueda)===1)?
                          <React.Fragment>
                          {usuario.Citems.map((ditem , dindex) => (
                            <tr>
                                <td>
                                  {ditem.usuario}
                                </td>
                                <td style={{"textAlign":"right"}}>
                                  {ditem.total}
                                </td>
                                <td style={{"textAlign":"right"}}>
                                  {ditem.vE}
                                </td>
                                <td style={{"textAlign":"right"}}>
                                  {ditem.vT}
                                </td>
                                <td style={{"textAlign":"right"}}>
                                  {ditem.delivery}
                                </td>
                                <td>
                                  {ditem.Forma_Pago}
                                </td>
                                <td>
                                  {ditem.sucursales}
                                </td>
                                <td>
                                  {ditem.codigo}
                                </td>
                                <td>
                                  {ditem.Cliente}
                                </td>
                                <td>
                                  {ditem.fecha_creacion}
                                </td>
                                <td>
                                  {ditem.cod_pedido}
                                </td>
                                <td>
                                  {ditem.total_kilometraje}
                                </td>
                            </tr>
                          ))}
                          </React.Fragment>
                          :null}
                          </React.Fragment>
                        ))}
                        </tbody>
                    </table>
                  </div>
                </div>
              </div>

   }
   if(id_tipo_reporte===6){
     const data_sucursal_transferencia = this.state.data_sucursal_transferencia
     const roundTo = require('round-to');
     modulo =  <div className="cssversion_pw100 cssversion_ph100">
                  <div className="cssversion_pw100 cssversion_ph10" style={{"display":"flex"}}>
                    <div className="cssversion_pw50 cssversion_ph100 cssversion_contentCenter">
                      <label>Desde</label><DatePicker selected={this.state.date_desde} onChange={this.onChangeDesde} onCalendarClose={this.handleCalendarClose} onCalendarOpen={this.handleCalendarOpen} /><br/>
                      <label>Hasta</label><DatePicker selected={this.state.date_hasta} onChange={this.onChangeHasta} onCalendarClose={this.handleCalendarClose} onCalendarOpen={this.handleCalendarOpen} />
                    </div>
                  </div>
                  <div className="cssversion_pw100 cssversion_ph10" style={{"display":"flex"}}>
                    <div className="cssversion_pw50 cssversion_ph100 cssversion_contentCenter">
                      <button className="button-global" style={{"width":"250px"}} onClick={ () => this.setReporteExportar(1)}>Buscar</button>
                    </div>
                  </div>
                </div>


   }
   if(id_tipo_reporte===7){
    const roundTo = require('round-to');
     modulo =  <div className="cssversion_pw100 cssversion_ph100">
                  <div className="cssversion_pw100 cssversion_ph10" style={{"display":"flex"}}>
                    <div className="cssversion_pw50 cssversion_ph100 cssversion_contentCenter">
                      <label>Desde</label><DatePicker selected={this.state.date_desde} onChange={this.onChangeDesde} onCalendarClose={this.handleCalendarClose} onCalendarOpen={this.handleCalendarOpen} /><br/>
                      <label>Hasta</label><DatePicker selected={this.state.date_hasta} onChange={this.onChangeHasta} onCalendarClose={this.handleCalendarClose} onCalendarOpen={this.handleCalendarOpen} />
                    </div>
                  </div>
                  <div className="cssversion_pw100 cssversion_ph90">
                    <div className="cssversion_pw80 cssversion_ph80">
                      <table className="tb_pedidos">
                        <thead>
                        <tr>
                          <th>Motorizado</th>
                          <th>Total</th>
                          <th>Efectivo</th>
                          <th>Tarjeta</th>
                          <th>Delivery</th>
                          <th>Forma de Pago</th>
                          <th>Sucursales</th>
                          <th>Código</th>
                          <th>Cliente</th>
                          <th>Fecha Pedido</th>
                          <th>Cód Pedido</th>
                          <th>Kilometraje</th>
                          <th>Opciones</th>
                        </tr>
                        </thead>
                        <tbody>
                          {this.state.data.map((ditem , dindex) => (
                            <tr>
                                <td>
                                  {ditem.usuario}
                                </td>
                                <td style={{"textAlign":"right"}}>
                                  {ditem.total}
                                </td>
                                <td style={{"textAlign":"right"}}>
                                  {ditem.vE}
                                </td>
                                <td style={{"textAlign":"right"}}>
                                  {ditem.vT}
                                </td>
                                <td style={{"textAlign":"right"}}>
                                  {ditem.delivery}
                                </td>
                                <td>
                                  {ditem.Forma_Pago}
                                </td>
                                <td>
                                  {ditem.sucursales}
                                </td>
                                <td>
                                  {ditem.codigo}
                                </td>
                                <td>
                                  {ditem.nombre}
                                </td>
                                <td>
                                  {ditem.Fecha_Pedido}
                                </td>
                                <td>
                                  {ditem.cod_pedido}
                                </td>
                                <td>
                                  {ditem.total_kilometraje}
                                </td>
                                
                                <td onClick={ () => this.ver_pedido(ditem.uuid_pedido,'vista_previa',ditem.id_estado_pedido)}  >Ver Pedido</td>
                                 
                            </tr>
                          ))}
                        </tbody>
                    </table>
                  </div>
                </div>
              </div>

   }
   let sub_pantalla_modal =null
   const sub_modal = this.state.sub_modal
    if(sub_modal==='vista_previa'){
      sub_pantalla_modal=<div id="loader_msg_sub" className="loader_msg_sub loader_msg_sub-default is-active" data-text="">
                          <GetNuevaOrden id_tipo_permiso={this.state.id_tipo_permiso}   separator={this.props.separator} url_image={this.props.url_image}   firebase={this.props.firebase}   file_500x200={this.props.file_500x200} file_250x200={this.props.file_250x200} file_60x60={this.props.file_60x60}  token_pedido={this.state.id_pedido} token={this.props.token} dir_url={this.props.dir_url} get_aceptar_pedido={this.get_salir_vista_pedido}/>
                        </div>
      }
    return(
      <React.Fragment>
      <div className="cssversion_menu cssversion_colorwhite" style={{"color":"black"}}>
        <div className="cssversion_pw100 cssversion_ph10 cssversion_colorblanco" style={{"display":"flex"}}>
          <div className="cssversion_pw10 cssversion_contentCenter" onClick={ () => this.props.get_salir_vista_pedido()}>
            <img className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128.png') } />
          </div>
          <div className="cssversion_pw90 cssversion_contentCenter" >
            <select className="select-css_global" value={this.state.id_tipo_reporte} onChange={(e) => {this.handleChanget(e)}}>
              <option value="0">Seleccione Tipo de Reporte</option>
              {(Number(this.props.id_tipo_permiso)!==5&&Number(this.props.id_tipo_permiso)!==2)?<option value="1">Ventas Globales por Año</option>:null}
              {(Number(this.props.id_tipo_permiso)!==5&&Number(this.props.id_tipo_permiso)!==2)?<option value="2">Domicilios Globales por Año</option>:null}
              {(Number(this.props.id_tipo_permiso)!==5&&Number(this.props.id_tipo_permiso)!==2)?<option value="3">Productos Vendidos por Fecha</option>:null}
              {(Number(this.props.id_tipo_permiso)!==5&&Number(this.props.id_tipo_permiso)!==2)?<option value="4">Top Clientes</option>:null}
              {(Number(this.props.id_tipo_permiso)!==5&&Number(this.props.id_tipo_permiso)!==2)?<option value="6">Reporte de tracking</option>:null}
              {(Number(this.props.id_tipo_permiso)!==5)?<option value="7">Reporte de Pedidos</option>:null}
              {(Number(this.props.id_tipo_permiso)!==2)?<option value="5">Reporte Motorizados</option>:null}
            </select>
          </div>
        </div>
        <div className="cssversion_pw100 cssversion_ph90" style={{"display":"flex"}}>
          <div className="cssversion_pw100 cssversion_ph100 cssversion_inlinetable" >
            <div className="cssversion_pw100 cssversion_ph100" style={{"overflowY":"auto"}}>
             {modulo}
              {sub_pantalla_modal}
            </div>
          </div>
        </div>
      </div>
      </React.Fragment>
    )
  }
  get_salir_vista_pedido = (token_pedido)=>{
    this.setState({
        id_pedido:'',sub_modal:''
      })
  }
  ver_pedido =(id_pedido,sub_modal,id_estado_pedido)=>{
 
      this.setState({
        id_pedido,sub_modal
      })
 
  }
  get_Sucursal =()=>{
    const url= this.props.dir_url + "webapp/getSucursalTransferencia";
    const token =  this.props.token
    const token_Pedido =  this.props.token_pedido
    let id_sucursal = 0// Number(this.props.id_sucursal)
    //this.state.id_tipo_subreporte
    if(Number(this.props.id_tipo_permiso)===5){
      id_sucursal = Number(this.props.id_sucursal)
    }

    var obj = { accion:'sucursaltransferencia', token, token_Pedido,id_sucursal:0};
    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      //console.log(data)
      if(data[0].status==="ok"){
        console.log(data[0].msg)
        this.setState({
          id_tipo_subreporte:id_sucursal,data_sucursal_transferencia:[data[0].msg]
        })
      }else{
        this.setState({
          id_tipo_subreporte:id_sucursal,data_sucursal_transferencia:[]
        })
      }
    })
    .catch(console.log)
  }
  componentDidMount (){
    this.get_Sucursal()
  }

}
export default getReportes;
